/**
 * How a heading glyph turns from one heading to the next. Pure: no Leaflet.
 */

/** A turn smaller than this, in degrees, leaves the glyph as it is. */
export const HEADING_MIN_TURN = 1;

/**
 * The CSS rotation, in degrees, that turns a glyph shown at `from` to `heading` (degrees
 * clockwise from north) the short way: from 359 to a heading of 1 is 361, not 1, so a transition
 * on the rotation turns 2° rather than 358° back. The result stays near `from` and is not reduced
 * to 0–360. Null when the turn is smaller than `HEADING_MIN_TURN`. With no `from`, the heading
 * itself, in 0–360.
 */
export function headingRotation(from: number | undefined, heading: number): number | null {
  if (from === undefined) return ((heading % 360) + 360) % 360;
  const turn = ((((heading - from) % 360) + 540) % 360) - 180;
  return Math.abs(turn) < HEADING_MIN_TURN ? null : from + turn;
}
